angular.module('unergie.main')
.directive('changePhone', ($filter, $uibModal, AlertManager, ApiUser, BoFeaturesService, AdminComments, ErrorCatcher) => ({
    restrict: 'E',
    scope: {
        account: '=',
        process: '=',
        onPhoneChange: '&?',
    },
    templateUrl: '/directives/changePhone/changePhone.html',
    link($scope) {
        const feats = BoFeaturesService.getModuleFeatures('accountinfo')
        const enableProcess = $scope.process === false ? false : feats.smsProcess
        $scope.isAIFeatureOn = (feature) => feats[feature]

        const chgPhoneTemplate = { newPhone: '', process: enableProcess }
        const newPhoneField = {
            newPhone: {
                required: true,
                label: 'Téléphone mobile français',
                type: 'phone',
            },
        }
        const processField = !enableProcess ? {} : {
            process: {
                required: true,
                label: 'Modif sans envoi',
                type: 'select',
                enum: [
                    { label: 'Avec envoi', value: true },
                    { label: 'Sans envoi (direct BDD)', value: false },
                ],
            },
        }
        $scope.chgPhonePayload = angular.copy(chgPhoneTemplate)
        $scope.chgPhoneFields = _.assign({}, newPhoneField, processField)

        const formatPhone = function (phone) {
            if (phone && (phone.indexOf('+33') < 0) && (phone.length === 10) && ((phone.indexOf('06') === 0) || (phone.indexOf('07') === 0))) {
                return `+33${phone.slice(1)}`
            }
            return phone
        }

        $scope.initChangePhone = () => {
            $scope.chgPhonePayload = _.assign({}, chgPhoneTemplate, { newPhone: $scope.account.phone })
        }

        const changePhoneDB = function () {
            const newPhone = formatPhone($scope.chgPhonePayload.newPhone)
            ApiUser.updateAccount({ id_account: $scope.account.id }, { phone: newPhone }).$promise.then(() => {
                AlertManager.success('Compte modifié')
                const comment = `<b>AUTOMATIQUE</b> : Numéro modifié, ancien : <b>${$filter('phone')($scope.account.phone)}</b>, nouveau : <b>${$filter('phone')(newPhone)}</b>`
                AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                $scope.onPhoneChange(angular.copy($scope.chgPhonePayload))
            }).catch(ErrorCatcher)
        }

        const checkCodeModal = function (code) {
            const modalInstance = $uibModal.open({
                animation: true,
                size: 'lg',
                controller: 'checkCodeModalCtrl',
                templateUrl: '/directives/accountinfo/checkCodeModal/checkCodeModal.html',
                resolve: {
                    code: () => code,
                },
            })
            return modalInstance.result.then((ok) => {
                if (ok) {
                    return changePhoneDB()
                }
                return AlertManager.success('Compte inchangé')
            })
        }

        $scope.changePhone = function () {
            const newPhone = formatPhone($scope.chgPhonePayload.newPhone)
            if (newPhone === $scope.account.phone) {
                AlertManager.error('Même numéro !')
            } else if ($scope.chgPhonePayload.process) {
                ApiUser.changePhone({ idAccount: $scope.account.id }, { phone: newPhone }).$promise.then((result) => {
                    AlertManager.success(`SMS envoyé au ${$filter('phone')(newPhone)} avec le code: ${result.code}`)
                    $scope.onPhoneChange(angular.copy($scope.chgPhonePayload))
                    checkCodeModal(result.code)
                }).catch(ErrorCatcher)
            } else {
                changePhoneDB()
            }
        }
    },
}))
